
export enum headType {
    none = 'none',
    _2C_XL = '2C-XL',
    _2C_S1S2 = '2C-S1S2',
}